<template>
  <div class="settings" >
    <v-container class="pt-10">
      <v-row class="py-2 px-3 pt-1">
        <v-responsive class="overflow-visible">
          <h1 class="subheading grey--text">
              Dashboard
          </h1>
        </v-responsive>
        <!-- <v-btn
              dark
              class="primary"
              @click.stop="">
              Start Update
        </v-btn> -->
      </v-row>
      <v-row class="px-3 pt-1 mb-6" >
        <DataSummaryUsers orgId="" userId="" :key="`${datesrange[0]}+${datesrange[1]}+'0'`" />
        <DataSummaryTranscripts orgId="" userId="" :key="`${datesrange[0]}+${datesrange[1]}+'1'`" />
      </v-row>

      <UsageTimeChart orgId="" userId="" :key="`${datesrange[0]}+${datesrange[1]}+'5'`" />

      <UsersTranscTable orgId="" :key="`${datesrange[0]}+${datesrange[1]}+'3'`" />
      <TranscTable orgId="" userId="" :key="`${datesrange[0]}+${datesrange[1]}+'2'`" /> 
      <UsersNotActivatedTable orgId="" userId="" :key="`${datesrange[0]}+${datesrange[1]}+'4'`" />
      
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  title: "Dashboard",

  components: {
    DataSummaryUsers: () => import("@/components/data/DataSummaryUsers"),
    DataSummaryTranscripts: () => import("@/components/data/DataSummaryTranscripts"),
    TranscTable: () => import("@/components/data/TranscTable"),
    UsersTranscTable: () => import("@/components/data/UsersTranscTable"),
    UsersNotActivatedTable: () => import("@/components/data/UsersNotActivatedTable"),
    UsageTimeChart: () => import("@/components/charts/UsageTimeChart"),
  },

  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      datesrange: "datesrange",
    }),
  },
  methods: {
  },
  mounted(){
  }
};
</script>

<style>
</style>